import { AutocompleteInput, ReferenceInput } from "react-admin";
import { useWatch } from "react-hook-form";
import {
  OptionRenderer,
  inputText,
  matchSuggestion,
} from "./OptionRenderer";

const PurchaseOrderReference = ({
  formData,
  dependOn,
  queryName, // company_id
  source,
  resource,
  reference,
  defaultFilters = {},
  ...props
}) => {
  const dependOnVal = useWatch({ name: dependOn });

  const exclude = { exclude_ids: [] };
  for (let i = 0; i < formData.customer_debt_payment_items.length; i++) {
    if (formData.customer_debt_payment_items[i].sale_id) {
      exclude.exclude_ids.push(formData.customer_debt_payment_items[i].sale_id);
    }
  }

  return (
    <ReferenceInput
      source={source} // color_id
      reference={reference} //"colors"
      perPage={20}
      sort={{
        field: resource + ".code",
        order: "ASC",
      }}
      filter={{
        [queryName]: dependOnVal,
        ...(exclude.exclude_ids.length ? exclude : {}),
        ...defaultFilters,
      }}
      enableGetChoices={(filters) => {
        return !!dependOnVal || !!filters.all;
      }}
    >
      <AutocompleteInput
        // label={label} // "mine.label.color"
        variant="outlined"
        fullWidth
        sx={{ display: "inline-flex" }}
        // validate={validateBrand}
        optionValue="id"
        // optionText="code"
        optionText={<OptionRenderer />}
        inputText={inputText}
        matchSuggestion={matchSuggestion}
        {...props}
        filterToQuery={(searchText) => ({
          all: searchText,
          [queryName]: dependOnVal,
        })}
      />
    </ReferenceInput>
  );
};

export default PurchaseOrderReference;
